/**
 * Club Map tab should stay inside the club detail shell (not fullscreen /map).
 */
export function clubMapTabPath(clubId) {
  return `/clubs/${clubId}?tab=map`;
}

export function clubMapDrawBoundaryPath(clubId) {
  return `/clubs/${clubId}?tab=map&intent=draw-boundary`;
}

/** True on the club Map tab (detail ?tab=map or legacy /map path). */
export function isClubMapTabLocation(pathname = '', search = '') {
  const path = String(pathname || '');
  if (/^\/clubs\/[^/]+\/map\/?$/.test(path)) return true;
  if (!/^\/clubs\/[^/]+\/?$/.test(path)) return false;
  try {
    return new URLSearchParams(search || '').get('tab') === 'map';
  } catch (_) {
    return false;
  }
}
